import type { IAnalyticsBarsProps } from './IAnalyticsBarsProps';

/** Картка зі смужками (прототип v4: «За статусом», «Відкриті за виконавцем», «Відкриті за пріоритетом»): підпис, смужка 10px, лічильник. */
export function AnalyticsBars({ title, bars }: IAnalyticsBarsProps) {
  const max = Math.max(1, ...bars.map((b) => b.count));
  return (
    <section className="an-card">
      <div className="an-card__title">{title}</div>
      <div className="an-bars">
        {bars.map((b) => (
          <div key={b.key} className="an-bar">
            <span className="an-bar__label" title={b.label}>{b.label}</span>
            <span className="an-bar__track"><span className="an-bar__fill" style={{ width: `${Math.round((b.count / max) * 100)}%`, background: b.color }} /></span>
            <span className="an-bar__count">{b.count}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
